import React, { useMemo } from "react";
import { InfiniteList2 } from "../../../../../common/components";
import ProjectsListRow from "../projects-list-row/ProjectsListRow";
import { translate } from "../../../../../common/providers";
import styles from "./ProjectsListTable.module.css";

export default function ProjectsListTable({
	isCanvas,
	onAddPartner,
	onAddUser,
	onChangeArchive,
	onDownload,
	onRelaunchDocs,
	onResetElastic,
	onSelectRow,
	projectsRequest,
}) {
	const tableHeaders = useMemo(
		() => ({
			name: translate("dsi.project-list.th.name"),
			created: translate("dsi.project-list.th.creation-date"),
			role: translate("dsi.project-list.th.company-role"),
			currentStatus: translate("dsi.project-list.th.status"),
			actions: translate("dsi.project-list.th.actions"),
		}),
		[]
	);
	const rowRenderer = (row) => (
		<ProjectsListRow
			isCanvas={isCanvas}
			row={row}
			onAddPartner={onAddPartner}
			onAddUser={onAddUser}
			onChangeArchive={onChangeArchive}
			onDownload={onDownload}
			onRelaunchDocs={onRelaunchDocs}
			onResetElastic={onResetElastic}
			onSelectRow={onSelectRow}
		/>
	);
	return (
		<>
			<ProjectsListRow isHeader row={tableHeaders} />
			<InfiniteList2 className={styles.container} request={projectsRequest} rowRenderer={rowRenderer} />
		</>
	);
}
